import JoyTooltip from '@mui/joy/Tooltip';
import { SxProps } from '@mui/joy/styles/types';
import { ReactElement, ReactNode } from 'react';

interface TooltipProps {
	children: ReactElement;
	title: ReactNode;

	sx?: SxProps;
	variant?: 'plain' | 'outlined' | 'soft' | 'solid' | undefined;
	disabled?: boolean;
	followCursor?: boolean;
	placement?:
		| 'bottom-end'
		| 'bottom-start'
		| 'bottom'
		| 'left-end'
		| 'left-start'
		| 'left'
		| 'right-end'
		| 'right-start'
		| 'right'
		| 'top-end'
		| 'top-start'
		| 'top';
	open?: boolean;
	arrow?: boolean;
}

export default function UiTooltip({ children, title, ...rest }: TooltipProps) {
	return (
		<JoyTooltip
			title={<div>{title}</div>}
			variant='solid'
			enterTouchDelay={0}
			{...rest}
		>
			{children}
		</JoyTooltip>
	);
}
